import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

import gibraltar1 from '../images/gibraltar1.jpeg';
import gibraltar2 from '../images/gibraltar2.jpeg';
import gibraltar3 from '../images/gibraltar3.jpeg';
import gibraltar4 from '../images/gibraltar4.jpeg';
import gibraltar5 from '../images/gibraltar5.jpeg';
import gibraltar6 from '../images/gibraltar6.jpeg';
import gibraltar7 from '../images/gibraltar7.jpeg';
import gibraltar8 from '../images/gibraltar8.jpeg';
import gibraltar9 from '../images/gibraltar9.jpeg';
import gibraltar10 from '../images/gibraltar10.jpeg';
import gibraltar11 from '../images/gibraltar11.jpeg';
import gibraltar12 from '../images/gibraltar12.jpeg';
import gibraltar13 from '../images/gibraltar13.jpeg';
import gibraltar14 from '../images/gibraltar14.jpeg';
import gibraltar15 from '../images/gibraltar15.jpeg';
import gibraltar16 from '../images/gibraltar16.jpeg';
import gibraltar17 from '../images/gibraltar17.jpeg';
import gibraltar18 from '../images/gibraltar18.jpeg';
import gibraltar19 from '../images/gibraltar19.jpeg';
import gibraltar20 from '../images/gibraltar20.jpeg';
import gibraltar21 from '../images/gibraltar21.jpeg';
import gibraltar22 from '../images/gibraltar22.jpeg';
import gibraltar23 from '../images/gibraltar23.jpeg';

function Gibraltar() {
    const navigate = useNavigate();
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  
    // Array of all imported images
    const photos = [
      gibraltar1, gibraltar2, gibraltar3, gibraltar4,
      gibraltar5, gibraltar6, gibraltar7, gibraltar8,
      gibraltar9, gibraltar10, gibraltar11, gibraltar12,
      gibraltar13, gibraltar14, gibraltar15, gibraltar16,
      gibraltar17, gibraltar18, gibraltar19, gibraltar20,
      gibraltar21, gibraltar22, gibraltar23
    ];
  
    // Function to handle image click
    const handleImageClick = (index) => {
      setSelectedImageIndex(index);
    };
  
    // Function to close the modal
    const closeModal = () => {
      setSelectedImageIndex(null);
    };
  
    // Function to navigate to the previous image
    const goToPrevious = () => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === 0 ? photos.length - 1 : prevIndex - 1
      );
    };
  
    // Function to navigate to the next image
    const goToNext = () => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === photos.length - 1 ? 0 : prevIndex + 1
      );
    };
  
    return (
      <div className="gibraltar-page">
        <h1>🇬🇮 Gibraltar 2025 🇬🇮</h1>
        <button className="back-button" onClick={() => navigate(-1)}>
          &larr; 
        </button>
  
        <div className="photo-grid">
          {photos.map((photo, index) => (
            <div
              key={index}
              className="photo-item"
              onClick={() => handleImageClick(index)}
            >
              <img src={photo} alt={`Gibraltar ${index + 1}`} />
            </div>
          ))}
        </div>
  
        {/* Modal for displaying the larger image */}
        {selectedImageIndex !== null && (
          <div className="modal" onClick={closeModal}>
            <div className="modal-content">
              <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
                &larr;
              </button>
              <img
                src={photos[selectedImageIndex]}
                alt="Selected"
                className="modal-image"
              />
              <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
                &rarr;
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
  
  export default Gibraltar;